<template>
      <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">{{ tipo === 'editar' ? 'Editar Role' : tipo === 'crear' ? 'Crear Role' : 'Ficha del rol' }}</span></h3>
          </v-card-title>
          <v-card-text>
            <v-text-field
                :disabled="tipo === 'ver'"
                ref="name"
                prepend-icon="code"
                v-model="form.name"
                :rules="[v => !!v || 'Nombre es requerido']"
                :error-messages="errName"
                label="Nombre"
                required
                ></v-text-field>

            <v-textarea
                :disabled="tipo === 'ver'"
                ref="description"
                prepend-icon="location_city"
                v-model="form.description"
                :rules="[v => !!v || 'La Description es requerido']"
                :error-messages="errDescription"
                label="Descripción"
                required
                counter="254"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog(null)">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="tipo !== 'ver'" :loading="loading" class="primary" @click="submit">{{ tipo === 'editar' ? 'Actualizar' : tipo === 'crear' ? 'Crear': 'Ver' }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
</template>

<script>
import axios from 'axios'
import Form from 'vform'

export default {
  name: 'form-role-view',

  props: {
    tipo: {
      type: String,
      required: true
    },
    datos: {
      type: Object,
      required: true
    }
  },

  watch: {
    datos(v) {
      this.$refs.form.resetValidation()
      if (this.tipo == "crear") {
        Object.assign(this.form, this.formOld)
      }else {
        Object.assign(this.form, v)
      }
    }
  },

  data: () => ({
    errName: [],
    errDescription: [],
    valid: false,
    loading: false,
    form: new Form({
        name: '',
        description: ''
    }),
    formOld:{
        name: '',
        description: ''
    }
  }),

  mounted() {
    this.$store.dispatch('clearMessage')
  },

  methods: {

    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.submitFormRoles()
      }
    },

    async submitFormRoles () {
      try {
        if (this.tipo == 'crear') {
          const { data } = await axios.post('/api/roles/admin/create_role', this.form)
          this.cerrarDialog(data)
        }else {
          const { data } = await axios.patch('/api/roles/admin/update_role', this.form)
          this.cerrarDialog(data)
        }
      } catch (e) {
        console.log(e.response, 'data error create')
        this.loading = false
        if (e.response.data.errors) {
          this.form.errors.errors = e.response.data.errors
          if (e.response.data.errors.name) {
            this.$refs.name.focus()
            //this.errName.push('name ya existe')
            this.$store.dispatch('responseMessage', {
              type: 'error',
              text: e.response.data.errors.name[0]
            })
          }
        }else {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            text: e.response.data.error
          })
        }
      }

    },

    cerrarDialog (data) {
      this.$emit('closeDialogRole', data)
      this.$nextTick(() => {
        //this.errTit = []
        this.$refs.form.resetValidation()
        this.loading = false
     })
    }

  }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/formRole.vue